// Shared helper to build wa.me URLs with precompiled messages
// Italian numbers without country code are auto-prefixed with +39

const normalizeDigits = (phone) => {
  if (!phone) return null;
  let digits = String(phone).replace(/[^\d]/g, "");
  if (!digits) return null;
  if (digits.length <= 10) digits = "39" + digits; // assume IT
  return digits;
};

const firstNameOf = (fullName) => (fullName || "").trim().split(/\s+/)[0] || "";

export const buildWhatsAppLink = (phone, message) => {
  const digits = normalizeDigits(phone);
  if (!digits) return null;
  return `https://wa.me/${digits}?text=${encodeURIComponent(message || "")}`;
};

// Quote sent to client
export const waMessageForQuote = (clientName) => {
  const fn = firstNameOf(clientName);
  const greeting = fn ? `Ciao ${fn},` : "Ciao,";
  return `${greeting} ti invio il preventivo per il tuo soggiorno al B&B Emmanuel a Reggio Calabria. A presto!`;
};

// Receipt sent to client
export const waMessageForReceipt = (clientName, receiptNumber, total) => {
  const fn = firstNameOf(clientName);
  const greeting = fn ? `Ciao ${fn},` : "Ciao,";
  let msg = `${greeting} ti invio la ricevuta del tuo soggiorno al B&B Emmanuel`;
  if (receiptNumber) msg += ` (N° ${receiptNumber})`;
  if (total) msg += ` · Totale: € ${Number(total).toFixed(2)}`;
  msg += `. Grazie per averci scelto! 🌊`;
  return msg;
};


// Returning / past guest re-engagement
export const waMessageForCustomer = (firstName) => {
  const fn = firstName || "";
  const greeting = fn ? `Ciao ${fn},` : "Ciao,";
  return `${greeting} qui Emmanuel del B&B Emmanuel di Reggio Calabria. Ti scrivo per il tuo prossimo soggiorno da noi 🌊`;
};

// Reply to a flexible-request (no availability) message
export const waMessageForFlexibleRequest = (firstName, checkIn, checkOut) => {
  const fn = firstName || "";
  const greeting = fn ? `Ciao ${fn},` : "Ciao,";
  let body = ` grazie per averci scritto al B&B Emmanuel.`;
  if (checkIn && checkOut) {
    body += ` Riguardo alla tua richiesta per ${checkIn} → ${checkOut},`;
  }
  body += ` ti rispondo subito con una proposta su misura.`;
  return greeting + body;
};

// Extract a phone from a free-text message (used for legacy flexible_request docs)
export const extractPhone = (text) => {
  if (!text) return null;
  const m = /(?:Telefono|Phone|Tel)\s*:?\s*([+\d][\d\s\-./()]{6,})/i.exec(text);
  if (!m) return null;
  const cleaned = m[1].replace(/[^\d+]/g, "");
  if (cleaned.replace(/\D/g, "").length < 6) return null;
  return cleaned;
};
